// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiCommunityMetric } from '../models/ApiCommunityMetric';
import { HttpFile } from '../http/http';

export class ApiCommunityMetrics {
    'drops_created': ApiCommunityMetric;
    'distinct_droppers': ApiCommunityMetric;
    'main_stage_submissions': ApiCommunityMetric;
    'main_stage_distinct_voters': ApiCommunityMetric;
    'main_stage_votes': ApiCommunityMetric;
    'network_tdh': ApiCommunityMetric;
    'tdh_on_main_stage_submissions': ApiCommunityMetric;
    'consolidations_formed': ApiCommunityMetric;
    'xtdh_granted': ApiCommunityMetric;
    'active_identities': ApiCommunityMetric;
    'profile_count': ApiCommunityMetric;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "drops_created",
            "baseName": "drops_created",
            "type": "ApiCommunityMetric",
            "format": ""
        },
        {
            "name": "distinct_droppers",
            "baseName": "distinct_droppers",
            "type": "ApiCommunityMetric",
            "format": ""
        },
        {
            "name": "main_stage_submissions",
            "baseName": "main_stage_submissions",
            "type": "ApiCommunityMetric",
            "format": ""
        },
        {
            "name": "main_stage_distinct_voters",
            "baseName": "main_stage_distinct_voters",
            "type": "ApiCommunityMetric",
            "format": ""
        },
        {
            "name": "main_stage_votes",
            "baseName": "main_stage_votes",
            "type": "ApiCommunityMetric",
            "format": ""
        },
        {
            "name": "network_tdh",
            "baseName": "network_tdh",
            "type": "ApiCommunityMetric",
            "format": ""
        },
        {
            "name": "tdh_on_main_stage_submissions",
            "baseName": "tdh_on_main_stage_submissions",
            "type": "ApiCommunityMetric",
            "format": ""
        },
        {
            "name": "consolidations_formed",
            "baseName": "consolidations_formed",
            "type": "ApiCommunityMetric",
            "format": ""
        },
        {
            "name": "xtdh_granted",
            "baseName": "xtdh_granted",
            "type": "ApiCommunityMetric",
            "format": ""
        },
        {
            "name": "active_identities",
            "baseName": "active_identities",
            "type": "ApiCommunityMetric",
            "format": ""
        },
        {
            "name": "profile_count",
            "baseName": "profile_count",
            "type": "ApiCommunityMetric",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiCommunityMetrics.attributeTypeMap;
    }

    public constructor() {
    }
}

